export default "__VITE_ASSET__46ac80ed__"